import { getStateCodes } from './getStateCodes';

export function isStateRequired({ countryCode }: Readonly<{ countryCode: string }>): boolean {
	return !!getStateCodes({ countryCode }).length;
}
